<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <prospective-projects
                v-if="!!report"
                :dataset="report.dataset['prospective-projects']"
                :state="state"
                class="uk-margin-large-bottom"
                @set-state-value="set_state_value"
            />

            <div class="lam-cards">
                <div class="lam-card">
                    <div class="uk-panel uk-panel-box">
                        <div class="uk-grid uk-grid-small uk-margin-large-bottom lam-graph">
                            <div class="uk-width-1-2" style="position: relative;">
                                <h3 class="uk-panel-title uk-margin-small-top">TYPES BY COUNT</h3>
                                <prospective-projects-by-types-graph
                                    ref="chart"
                                    :chart-data="chart_data('count')"
                                    :legend-position="!!state.category_id ? 'bottom' : 'right'"
                                    units="count"
                                    :y-max="ymax"
                                    :style="{ height: `${!!state.category_id ? 500 : 300}px` }"
                                />
                            </div>
                            <div class="uk-width-1-2" style="position: relative;">
                                <h3 class="uk-panel-title uk-margin-small-top">TYPES BY FEE</h3>
                                <prospective-projects-by-types-graph
                                    ref="chart"
                                    :chart-data="chart_data('total')"
                                    :legend-position="!!state.category_id ? 'bottom' : 'right'"
                                    units="total"
                                    :y-max="ymax"
                                    :style="{ height: `${!!state.category_id ? 500 : 300}px` }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <top-clients
                v-if="!!report"
                :dataset="report.dataset['top-clients']"
                :state="state"
                @set-state-value="set_state_value"
            />
        </div>
    </report>
</template>

<script type="text/javascript">
import is_report from "./IsReport"
import uses_color_palette from "../../mixins/UsesColorPalette"

import Report from "./Report.vue"
import ProspectiveProjectsByTypesGraph from "./ProspectiveProjectsByTypesGraph.js"
import ProspectiveProjects from "./ProspectivesDashboard/ProspectiveProjects.vue"
import TopClients from "./ProspectivesDashboard/TopClients.vue"

export default {
    mixins: [is_report, uses_color_palette],
    components: {
        Report,
        ProspectiveProjectsByTypesGraph,
        ProspectiveProjects,
        TopClients
    },
    watch: {
        "state.category_id": "load",
        "state.type_scope": "load"
    },
    methods: {
        chart_data (units) {
            const data = { labels: [], datasets: [] }

            if(this.report && this.report.dataset["prospectives-by-types"]) {
                data.labels = Object.keys(this.report.dataset["prospectives-by-types"])

                const grand_total = Object.values(this.report.dataset["prospectives-by-types"]).reduce((total, value) => {
                    return total + value[this.state.filter][units]
                }, 0)
                const dataset = {
                    data: [],
                    backgroundColor: [],
                    borderColor: []
                }

                data.labels.forEach(label => {
                    const color = this.report.dataset["prospectives-by-types"][label]._color ? { background: this.report.dataset["prospectives-by-types"][label]._color, border: this.report.dataset["prospectives-by-types"][label]._color } : this.assigned_color(label)
                    const value = (this.report.dataset["prospectives-by-types"][label][this.state.filter][units] / grand_total) * 100
                    dataset.data.push(value)
                    dataset.backgroundColor.push(color.background)
                    dataset.borderColor.push(color.border)
                })

                data.datasets.push(dataset)
            }

            return data
        }
    },
    computed: {
        fields () {
            return ["ns::project;fieldset::graph"]
        },
        capacities () {
            return [
                "Any",
                this.$root.constants.terms.PROJECT_USER_ROLE_PIC,
                this.$root.constants.terms.PROJECT_USER_ROLE_PM,
                this.$root.constants.terms.PROJECT_USER_ROLE_DESIGNER
            ]
        }
    },
    data () {
        return {
            report_id: "prospectives_dashboard",

            default_state: {
                type_scope: 1,
                scope: "0",
                projects_scope: "weeks",
                mode: "absolute",
                filter: "Any", // capacity
                user_id: 0,
                studio_id: 0,
                units: "count",
                category_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
